export const config = {
  appConfig: {
    env: 'development',
    apiGrpcEndpoint: 'https://grpc-dev.baandy.com/',
    apiCdnEndpoint: 'https://rest-dev.baandy.com/',
    assetCdnEndpoint: 'https://assets-dev.baandy.com/',
    apiOrderEndpoint: 'https://order-dev.baandy.com/',
    apiExpressEndpoint: 'https://express-dev.baandy.com/',
    backofficeEndpoint: 'https://api-dev.baandy.com',
    merchantID: 5,
    googleMapKey: 'AIzaSyA4WkmCayFZC6RJCe5xN3NZ4M7zI0KT-kA',
    publicFrontEndpoint: 'https://dev.baandy.com/apps/',
  },
  themeConfig: {
    colors: {
      primary: '#F37720', //orange
      primary1: '#FFFFFF', //white
      primary2: '#F0F0F0', //greylight
      drakGrey: '#575756',
      grey: '#999999',
      white: '#fff',
      black: '#000',
      whitebg: '#f8fafb',
      secondary: '#FDE4D2',
      transparent: 'transparent',
      success: '#7cb305',
      error: '#f5222d',
      warning: '#faad14',
      disable: '#999999',
      backgroundGradient: 'linear-gradient(180deg, #F37720 27.6%, #FFB800 100%)',
    },
    fontFamily: {
      primary: 'Kanit',
      regular: 'Kanit',
      medium: 'KanitMedium',
      bold: 'KanitSemiBold',
    },
  },
}

export default config
